import styled from '@emotion/styled'

export const Version = styled.div`
	text-align: center;
	color: #acacac;
	font-size: 12px;
	padding: 5px 0;
`
